import { Grid, Box, makeStyles, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../../theme/colors";
import { TextInput } from "../../../../components/base";

const useStyles = makeStyles(() => ({
  headerBox: {
    display: "flex",
    alignItems: "center",
    borderRadius: 15,
    backgroundColor: COLORS.white,
    padding: "3px 0",
  },
  headerBoxItem: {
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
  },
  inputRootStyle: {
    padding: 5,
    paddingRight: 0,
    color: COLORS.purple,
  },
  rootStyle: {
    "& .MuiOutlinedInput-adornedEnd": {
      paddingRight: 4,
      color: COLORS.purple,
    },
    "& .MuiOutlinedInput-adornedStart": {
      paddingLeft: 4,
      color: COLORS.purple,
    },
  },
  headerBoxInput: {
    marginLeft: 2,
  },
  line: {
    height: 10,
    width: 2,
    backgroundColor: COLORS.darks[0][10],
  },
  containerStyle: {
    padding: 0,
  },
  star: {
    height: 25,
    fontSize: 24,
    color: COLORS.purple,
  },
  formDataValueTypography: {
    paddingLeft: 2,
  },
}));

export const SAHeaderBox = ({ formData, handleChange, editable, title }) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <Grid container alignItems="center" style={{ marginBottom: 30 }}>
      {title ? (
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Typography className={classes.star}>*</Typography>
          <Typography style={{ fontWeight: 700 }}>{title}</Typography>
        </Box>
      ) : null}
      <Box className={classes.headerBox}>
        <Box className={classes.headerBoxItem}>
          <Typography>Sold Electricity Margin:</Typography>
          {editable ? (
            <Box className={classes.headerBoxInput} style={{ width: 48 }}>
              <TextInput
                fullWidth
                containerStyle={classes.containerStyle}
                inputRootStyle={classes.inputRootStyle}
                rootStyle={classes.rootStyle}
                endAdornment="%"
                value={formData.sold.value}
                onChange={(value) => handleChange("sold", value)}
              />
            </Box>
          ) : (
            <Typography className={classes.formDataValueTypography}>{formData.sold}</Typography>
          )}
        </Box>
        <Box className={classes.line}></Box>
        <Box className={classes.headerBoxItem}>
          <Typography>Purchased Electricity Margin:</Typography>
          {editable ? (
            <Box className={classes.headerBoxInput} style={{ width: 48 }}>
              <TextInput
                fullWidth
                containerStyle={classes.containerStyle}
                inputRootStyle={classes.inputRootStyle}
                rootStyle={classes.rootStyle}
                endAdornment="%"
                value={formData.purchased.value}
                onChange={(value) => handleChange("purchased", value)}
              />
            </Box>
          ) : (
            <Typography className={classes.formDataValueTypography}>
              {formData.purchased}
            </Typography>
          )}
        </Box>
        <Box className={classes.line}></Box>
        <Box className={classes.headerBoxItem}>
          <Typography>PRaaS AI & Digitalization Impact - Over Time:</Typography>
          {editable ? (
            <Box className={classes.headerBoxInput} style={{ width: 48 }}>
              <TextInput
                fullWidth
                containerStyle={classes.containerStyle}
                inputRootStyle={classes.inputRootStyle}
                rootStyle={classes.rootStyle}
                endAdornment="%"
                value={formData.praas.value}
                onChange={(value) => handleChange("praas", value)}
              />
            </Box>
          ) : (
            <Typography className={classes.formDataValueTypography}>{formData.praas}</Typography>
          )}
        </Box>
        <Box className={classes.line}></Box>
        <Box className={classes.headerBoxItem}>
          <Typography>Gas Prices:</Typography>
          {editable ? (
            <Box className={classes.headerBoxInput} style={{ width: 68 }}>
              <TextInput
                fullWidth
                containerStyle={classes.containerStyle}
                inputRootStyle={classes.inputRootStyle}
                rootStyle={classes.rootStyle}
                startAdornment={`${currencySymbol}32/`}
                value={formData.gas.value}
                onChange={(value) => handleChange("gas", value)}
              />
            </Box>
          ) : (
            <Typography className={classes.formDataValueTypography}>{formData.gas}</Typography>
          )}
        </Box>
      </Box>
    </Grid>
  );
};

SAHeaderBox.defaultProps = {
  editable: true,
};
